export const createSelectedTitle = (searchValue: string, title: string) => {
  const regex = new RegExp(`(${searchValue})`, "gi");
  const parts = title.split(regex);

  return <span>{parts.map((part, i) => (regex.test(part) ? <mark key={i}>{part}</mark> : part))}</span>;
};
